import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery__photo-button"
}
const _hoisted_2 = { class: "gallery__slider" }
const _hoisted_3 = {
  class: "gallery__frame",
  ref: "frame"
}
const _hoisted_4 = {
  key: 1,
  class: "gallery__buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gallery", {'gallery--expanded': _ctx.expanded}])
  }, [
    _createElementVNode("div", {
      class: "gallery__outer-container",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.expanded && _ctx.toggleExpand()))
    }, [
      (_ctx.images.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.currentSlide) + " / " + _toDisplayString(_ctx.images.length), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", {
            class: "gallery__slides",
            style: _normalizeStyle(_ctx.stripPosition),
            ref: "strip"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "gallery__item",
                style: _normalizeStyle('background-image: url(' + image + ')')
              }, "   ", 4 /* STYLE */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 4 /* STYLE */)
        ], 512 /* NEED_PATCH */)
      ]),
      (_ctx.images.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "gallery__prev",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)), ["stop"]))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "gallery__button" }, [
                _createElementVNode("svg", {
                  height: "24",
                  viewBox: "0 0 24 24",
                  width: "24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" })
                ])
              ], -1 /* CACHED */)
            ]))]),
            _createElementVNode("div", {
              class: "gallery__next",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["stop"]))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "gallery__button" }, [
                _createElementVNode("svg", {
                  height: "24",
                  viewBox: "0 0 24 24",
                  width: "24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
                ])
              ], -1 /* CACHED */)
            ]))])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}